module.exports = __webpack_public_path__ + "img/three.ce84cfd5.svg";